import { gql } from "@apollo/client";

import { TUTOR_CERTIFICATE_FIELDS } from "../queries/tutorCertificates";

export const CREATE_TUTOR_CERTIFICATE = gql`
  mutation CreateTutorCertificate($input: UpdateTutorCertificateInput!) {
    createCertTutorCertificate(input: $input) {
      ...TutorCertificateFields
    }
  }
  ${TUTOR_CERTIFICATE_FIELDS}
`;

export const UPDATE_TUTOR_CERTIFICATE = gql`
  mutation UpdateTutorCertificate(
    $id: ID!
    $input: UpdateTutorCertificateInput!
  ) {
    updateCertTutorCertificate(id: $id, input: $input) {
      ...TutorCertificateFields
    }
  }
  ${TUTOR_CERTIFICATE_FIELDS}
`;

export const DELETE_TUTOR_CERTIFICATE = gql`
  mutation DeleteTutorCertificate($id: ID!) {
    deleteCertTutorCertificate(id: $id) {
      id
    }
  }
`;
